import { Box, Button, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import ViewInput from "../ViewInput/ViewInput";
import styles from "./form.module.css";
import { filterViewTypes } from "../../utils/Filters";
import { TrashFill } from "react-bootstrap-icons";
function TypeForm({
  payment,
  availableDiscountReason,
  availableViewTypes,
  handleDelete,
  onViewChange,
  userDetails,
  errors,
}) {
  const theme = useTheme();
  const [totalAmount, setTotalAmount] = useState(0);
  const filteredViewTypes = filterViewTypes(
    userDetails?.site?.type,
    availableViewTypes
  );

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column" }}
      className={styles.formSection}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "16px",
        }}
      >
        <Typography
          variant="h6"
          color={theme.palette.neutral[800]}
          fontWeight={600}
        >
          {payment?.name}
        </Typography>
        <Box>
          <Button
            variant="contained"
            sx={{
              width: "36px",
              height: "36px",
              padding: 0,
              margin: 0,
              minWidth: "auto",
              backgroundColor: theme.palette.neutral[50],
              "&:hover": {
                backgroundColor: theme.palette.neutral[100],
              },
            }}
            onClick={() => handleDelete(payment.identifier)}
            disableElevation
          >
            <TrashFill size={16} color={theme.palette.primary[600]} />
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          columnGap: "20px",
          flexWrap: "wrap",
          width: "100%",
        }}
      >
        {filteredViewTypes?.length > 0 &&
          filteredViewTypes.map((v, i) => (
            <ViewInput
              payment={payment}
              viewType={v}
              availableDiscountReason={availableDiscountReason}
              key={`${payment?.id}-${v.id}-${i}`}
              totalAmount={totalAmount}
              setTotalAmount={setTotalAmount}
              onViewChange={onViewChange}
              userDetails={userDetails}
              
              errors={errors}
            />
          ))}
      </Box>
    </Box>
  );
}

export default TypeForm;
